import React, { useRef, useState } from "react";
import DataLinkProps from "./DataLink";
import { useHistory } from "react-router-dom";

const DataLink = React.memo(({
  children,
  className = '',
  href,
  inline = true,
  options = {},
  underline = true
}: DataLinkProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const history = useHistory();
  const [classList] = useState<string>(`${underline ? `underline hover:no-underline ` : ``}cursor-pointer ${className}`);

  return inline ?
    <span className={`${classList} inline-block`} onClick={() => history.push(href, options)}>{children}</span>
    :
    <div className={`${classList} block`} onClick={() => history.push(href, options)}>{children}</div>
    ;
});
export default DataLink;